import { render } from "./Canchas.vue?vue&type=template&id=e749e128&ts=true"
import script from "./Canchas.vue?vue&type=script&lang=ts"
export * from "./Canchas.vue?vue&type=script&lang=ts"

import exportComponent from "/root/app/github/pehuen-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__